module.exports = "pegasus_template/assets/themecapture1/small/home-bg.png";